import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import _ from 'lodash';
import {Permission} from '../../types/permission-group/permission';

export interface permissionState {
  value: {
    permissions: Permission[];
  };
  ecaPermissions: Permission[];
  allPermissions: Permission[];
}

const initialState: permissionState = {
  value: {permissions: []},
  ecaPermissions: [],
  allPermissions: [],
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<permissionState>) {
      const permissions = _.get(action.payload, 'value.permissions', []);
      const noneECAPermission = permissions.filter(
        (item) => item.type !== 'ECA'
      );
      const ecaPermissions = permissions.filter((item) => item.type === 'ECA');
      state.value.permissions = noneECAPermission;
      state.allPermissions = permissions;
      state.ecaPermissions = ecaPermissions;
    },
  },
  selectors: {
    getPermissions(state) {
      if (state.value) return state.value.permissions;
    },
    getECAPermissions(state) {
      return state.ecaPermissions;
    },
  },
});

export const {setPermissions} = permissionsSlice.actions;
export const {getPermissions, getECAPermissions} = permissionsSlice.selectors;

export default permissionsSlice.reducer;
